import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3'

export const RecaptchaProvider = ({ children }) => {
  return (
    <GoogleReCaptchaProvider
      reCaptchaKey={process.env.NEXT_PUBLIC_RECAPTCHA_CLIENT_KEY}
      language="ja"
    >
      {children}
    </GoogleReCaptchaProvider>
  )
}
